import {FETCH_CAMERAS_REQUEST, CREATE_CAMERA_REQUEST, UPDATE_CAMERA_REQUEST, DELETE_CAMERA_REQUEST, FETCH_CAMERAS_BY_PERMISSION_REQUEST} from './constants'

export function fetchCameras() {
  return {type: FETCH_CAMERAS_REQUEST}
}

export function fetchCamerasByPermission() {
  return {type: FETCH_CAMERAS_BY_PERMISSION_REQUEST}
}

export function postCamera(newCameraState) {
  return {type: CREATE_CAMERA_REQUEST, newCameraState}
}

export function updateCamera(updateCameraState) {
  return {type: UPDATE_CAMERA_REQUEST, updateCameraState}
}

export function deleteCamera(deleteCameraState) {
  return {type: DELETE_CAMERA_REQUEST, deleteCameraState}
}



// WEBPACK FOOTER //
// ./src/actions/camera.js